import { render, staticRenderFns } from "./IMMessage.vue?vue&type=template&id=c9a132ae&scoped=true"
import script from "./IMMessage.vue?vue&type=script&lang=ts"
export * from "./IMMessage.vue?vue&type=script&lang=ts"
import style0 from "./IMMessage.vue?vue&type=style&index=0&id=c9a132ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a132ae",
  null
  
)

export default component.exports